import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import EmpathySection from "./components/EmpathySection";
import ProblemSection from "./components/ProblemSection";
import MechanismSection from "./components/MechanismSection";
import ComparisonSection from "./components/ComparisonSection";
import StatsSection from "./components/StatsSection";
import FlexibleSection from "./components/FlexibleSection";
import LineFlowSection from "./components/LineFlowSection";
import TestimonialSection from "./components/TestimonialSection";
import FAQSection from "./components/FAQSection";
import CompanySection from "./components/CompanySection";
import FixedCTA from "./components/FixedCTA";

export default function Home() {
  return (
    <div className="font-sans">
      <Navbar />
      <main>
        {/* ファーストビュー */}
        <HeroSection />
        {/* 共感 */}
        <EmpathySection />
        {/* 問題の本質 */}
        <ProblemSection />
        {/* YAMEBIの仕組み */}
        <MechanismSection />
        {/* 比較 */}
        <ComparisonSection />
        {/* 統計・モニター試験 */}
        <StatsSection />
        {/* 生活に合わせて使える */}
        <FlexibleSection />
        {/* LINE追加後の流れ */}
        <LineFlowSection />
        {/* お客様の声 */}
        <TestimonialSection />
        {/* FAQ */}
        <FAQSection />
        {/* 会社情報 */}
        <CompanySection />
      </main>
      {/* 下部固定CTA */}
      <FixedCTA />
    </div>
  );
}
